import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.saveAndAddButton =
      this.element.querySelector('[name="save_and_add"]') ||
      (this.element.id &&
        document.querySelector(`[name="save_and_add"][form="${this.element.id}"]`))

    if (this.saveAndAddButton) {
      this.boundHandleSaveAndAdd = this.handleSaveAndAdd.bind(this)
      this.saveAndAddButton.addEventListener('click', this.boundHandleSaveAndAdd)
    }
  }

  disconnect() {
    if (this.saveAndAddButton && this.boundHandleSaveAndAdd) {
      this.saveAndAddButton.removeEventListener('click', this.boundHandleSaveAndAdd)
    }
  }

  // The synchronized textarea already holds the editor HTML for submit.
  beforeSubmit() {
    return true
  }

  // Called when "Create and Add Another" button is clicked.
  // Submits via fetch to avoid page reload, keeping the modal open.
  // Server responds with Turbo Streams to update task list and show flash.
  async handleSaveAndAdd(event) {
    event.preventDefault()

    const formData = new FormData(this.element)
    formData.append('save_and_add', 'true')
    
    try {
      const response = await fetch(this.element.action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        }
      })
      
      const html = await response.text()
      Turbo.renderStreamMessage(html)
      
      if (response.ok) this.resetForm()
    } catch (error) {
      console.error('Error creating task:', error)
      this.element.submit()
    }
  }

  resetForm() {
    const nameInput = this.element.querySelector('input[name="procedure_task[name]"]')
    if (nameInput) {
      nameInput.value = ''
      nameInput.focus()
    }

    const descriptionInput = this.element.querySelector(
      'textarea[name="procedure_task[description]"]',
    )
    if (descriptionInput) {
      descriptionInput.value = ''
      descriptionInput.dispatchEvent(new Event('input', { bubbles: true }))
      descriptionInput
        .closest('[data-controller~="editor"]')
        ?.dispatchEvent(
          new CustomEvent('editor:set-content', {
            detail: { content: '' },
          }),
        )
    }

    const optionalCheckbox = this.element.querySelector('input[name="procedure_task[optional]"]')
    if (optionalCheckbox) optionalCheckbox.checked = false
  }
}
